import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=200b6cb6&scoped=true&"
import script from "./EmailComponent.vue?vue&type=script&lang=js&"
export * from "./EmailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b6cb6",
  null
  
)

export default component.exports